import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const UserIcon = ({ color = '#9BA8AC', size = 16, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 18 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.8 10.068C15.338 3.508 12.736 0 9 0 5.19 0 2.652 3.643 6.201 10.068c1.198 2.168-1.294 2.679-3.818 3.252-2.578.585-2.38.255-2.38 2.68h17.993c0-2.425.199-2.095-2.38-2.68-2.578-.585-4.98-1.097-3.817-3.252z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

UserIcon.propTypes = propTypes;

export default UserIcon;
